export enum UserGroupEnum {
    Administrator = "Administrator",
    Broker = "Broker",
    Support = "Support",
    TraineeBroker = "Trainee Broker",
    SupportManager = "Support Manager",
    Care = "Care",
    Finance = "Finance",
    Guest = "Guest"
}